import styled from 'styled-components'
import { Row } from 'reactstrap'
import { Link } from 'react-router-dom'

export const DashboardLink = styled(Link)`
    color: var(----fai-text-color);
    
    &:hover {
        color: var(----fai-text-color);
    }
`

export const DashboardRow = styled(Row)`
    margin: 0;
    padding: 8px;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Pages/Dashboard.js